<h1>You don't have permissions to view this content.</h1>
<h2>Please login as a different user.</h2>

<tngh-button
  (click)="logout()"
  i18n-label="logout button|Permission denied screen logout user@@PermissionLogoutButton"
  label="Logout" />
